export function formatProtocolsInstanceStatus(status) {
    switch (status) {
        case 'created':
            return 'Get Started';
        case 'in_draft':
            return 'In Draft';
        case 'needs_review':
            return 'Needs Review';
        case 'submitted':
            return 'Generating PDF';
        case 'finalized':
            return 'Complete';
        case 'closed':
            return 'Closed';
        default:
    }
    return status;
}
